import IIco from './index.vue';

export {
    IIco,
};

export default IIco;
